import React from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 500,
    minHeight: 200,
    maxWidth: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#f4f4f4',
    padding: '1em 2.5em',
    position: 'relative',
  },
  title: {
    width: '100%',
    fontSize: '1.25em',
    textAlign: 'center',
    paddingRight: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 8,
  },
  body: {
    padding: '1em 2.5em',
    overflowY: 'auto',
  },
  heading: {
    fontWeight: 500,
  },
  action: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  '@media(max-width: 500px)': {
    header: {
      padding: '1em 1.5em 5px',
    },
    paper: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    body: {
      padding: '1em 1.5em',
    },
  }
}));


function ReportError(props) {
  const classes = useStyles();
  const { title, content } = props.data;

  const handleClose = () => {
    props.close(false);
  }

  return (
    <Modal open={true} onClose={handleClose} className={classes.wrapper}>
      <div className={classes.paper}>
        <div className={classes.header}>
          <div className={classes.title}>{title}</div>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.body}>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
      </div>
    </Modal>
  );
}

export default ReportError;
